import styled from "styled-components";
import { Link } from "@viagogo/core/ui";
import { Image } from "src/website-apps/shared/components/image";

/**
 * TeamCard
 */
export const StyledLink = styled(Link)`
  height: auto;
  position: relative;
  width: auto;
`;

export const StyledTeamCard = styled.div`
  align-items: center;
  background-color: transparent;
  border-radius: ${(props) => props.theme.borderRadius.l};
  display: flex;
  flex-direction: row;
  height: 92px;
  position: relative;
  width: auto;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    &:hover {
      background-color: #f8f8f8;
    }
  }

  @media ${({ theme: { media } }) => media.desktop} {
    padding: ${(props) => props.theme.spacing(2.5)};
  }
`;

export const StyledTeamContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${(props) => props.theme.spacing(5)};
  width: calc(100% - 48px);
`;

export const StyledTeamName = styled.p`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${(props) => props.theme.colors.textDarker};
  display: -webkit-box;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 20px;
  overflow: hidden;
`;

export const StyledTicketsMessage = styled.span`
  color: ${(props) => props.theme.colors.textPrimary};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: 20px;
  margin-top: ${(props) => props.theme.spacing(1)};
`;

/**
 * TeamLogo
 */
export const StyledTeamLogo = styled.div<{ bgColor?: Maybe<string> }>`
  background-color: ${(props) => props.bgColor ?? "#C4CED4"};
  border-radius: ${(props) => props.theme.borderRadius.l};
  position: relative;
  height: 48px;
  width: 48px;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    height: 72px;
    width: 72px;
  }
`;

export const StyledTeamLogoImage = styled(Image)`
  height: 100%;
  object-fit: cover;
  scale: 0.75;
  width: 100%;
`;

export const StyledTeamImage = styled(Image)`
  border-radius: ${(props) => props.theme.borderRadius.l};
`;

export const StyledTeamInitial = styled.div`
  background-color: transparent;
  color: ${(props) => props.theme.colors.white};
  font-size: 28px;
  font-weight: 700;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  user-select: none;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    font-size: 42px;
  }
`;
